enum ContactFormResultType {
  SetLoading,
  SetVerified,
  SetSubmitted,
  SetDefaultSubject,
  SetCaptchaToken,
  SetDataFrom,
  SetDataTo,
  SetDataName,
  SetDataSubject,
  ResetDataSubject,
  SetDataCompany,
  SetDataMessage,
  ResetDataMessage,
  SetModalState,
  SetModalOpen,
}

export default ContactFormResultType
